<template>
	<v-container>
	<h2>Load the contents from the iso json file stored on the server</h2>
		<v-progress-circular
			indeterminate
			color="secondary"
			v-show="loading"
		></v-progress-circular>
		<v-spacer></v-spacer>
		<v-alert
			:type="alert.type"
			v-show="alert.show"
		>
			{{alert.message}}
		</v-alert>
		<v-btn @click="importIsoCodes"
			>{{ txt.btn.importIsoCodes }}
		</v-btn>
	</v-container>
</template>

<script>
import axios from 'axios'

export default {
	name: 'importIsoValues',
	data(){
		return {
			loading: false,
			alert: {
				message: '',
				type: 'info',
				show: false,
			},
			txt: {
				btn: {
					importIsoCodes: 'Import Iso Codes'
				}
			},
		}
	},
	methods: {
		async importIsoCodes(){
			this.loading = true
			try {
				await axios.put(config.baseAPIurl + '/admin-page/registration-iso-codes')
				this.alert.message = 'ISO codes are loaded into the database'
				this.alert.type = 'success'
			} catch (error) {
				this.alert.message = 'ISO codes could not be loaded'
				this.alert.type = 'error'
			}
			this.loading = false
			this.alert.show = true
			setTimeout(() => this.alert.show = false, 8000)	
		}
	}
}
</script>

<style>

</style>